import React, { useCallback, useState } from 'react'
import { Switch } from '@labrav/react-components'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import { useDispatch } from 'react-redux'
import { PartnerType, RequestFailureMessage } from '@labrav/common'

import { updateProductListingData } from '../../../modules/productsListing/action'
import { Product, ProductStatus } from '../../../modules/productsListing/types'
import { productStatusUpdateSuccessMessage } from '../../utils/constants'
import { useStyles } from './GoLiveButton.styles'

type Props = {
  row: Product
  partnerId: string
  partnerType?: PartnerType
}

export const alertMessages = {
  success: productStatusUpdateSuccessMessage,
  error: RequestFailureMessage,
}

export const GoLiveButton: React.FC<Props> = ({ row, partnerId }) => {
  const { classes } = useStyles()
  const dispatch = useDispatch()

  const [toggleChecked, setToggleChecked] = useState<boolean>(
    row.status === ProductStatus.PRODUCT_STATUS_AWS_TESTING ||
      row.status === ProductStatus.PRODUCT_STATUS_PUBLIC
  )

  const isToggleDisabledForStatus = (status: string) => {
    switch (status) {
      case ProductStatus.PRODUCT_STATUS_PUBLIC:
      case ProductStatus.PRODUCT_STATUS_IN_PROGRESS:
      case ProductStatus.PRODUCT_STATUS_LIMITED:
      case ProductStatus.PRODUCT_STATUS_DRAFT:
      case ProductStatus.PRODUCT_STATUS_CREATION_FAILED:
      case ProductStatus.PRODUCT_STATUS_RESTRICTED:
      case ProductStatus.PRODUCT_STATUS_AWS_TESTING:
      case ProductStatus.PRODUCT_STATUS_REJECTED:
        return true
      case ProductStatus.PRODUCT_STATUS_LABRA_TESTING:
        return false
      default:
        return true
    }
  }
  const isToggleDisabled = isToggleDisabledForStatus(row.status)
  const handleToggleChecked = () => setToggleChecked(false)

  const toggle = useCallback(async () => {
    setToggleChecked(!toggleChecked)
    await dispatch(
      updateProductListingData({
        partnerId,
        productId: row.productId,
        data: {
          status: ProductStatus.PRODUCT_STATUS_AWS_TESTING,
        },
        alertMessages,
        handleToggleChecked,
      }) as never
    )
  }, [dispatch, partnerId, row.productId, toggleChecked])

  return (
    <Typography
      component="div"
      className={classes.wrapper}
      data-testid="GoLiveButton"
    >
      <Grid
        component="label"
        container
        className={classes.MuiGridContainer}
        spacing={1}
        sx={{
          alignItems: 'center',
        }}
      >
        <Grid>
          <Switch
            disabled={isToggleDisabled}
            checked={toggleChecked}
            onChange={() => toggle()}
          />
        </Grid>
      </Grid>
      <Grid
        container
        className={classes.syncLabel}
        sx={{
          alignItems: 'center',
        }}
      >
        Go live
      </Grid>
    </Typography>
  )
}
